var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRequestAccessDashboard(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 355,
    height: 356,
    viewBox: "0 0 355 356",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1465_4942",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: -2,
    y: -1,
    width: 359,
    height: 358
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -1.41016,
    y: 64.0234,
    width: 300,
    height: 300,
    rx: 7.8125,
    transform: "rotate(-12.5 -1.41016 64.0234)",
    fill: "url(#paint0_radial_1465_4942)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1465_4942)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 155.37,
    y: 163.914,
    width: 37.1094,
    height: 37.1094,
    rx: 7.61719,
    transform: "rotate(-12.5 155.37 163.914)",
    stroke: "#B5B5C2",
    strokeWidth: 0.390625
  }), /*#__PURE__*/React.createElement("rect", {
    x: 133.006,
    y: 149.648,
    width: 74.6094,
    height: 74.6094,
    rx: 7.61719,
    transform: "rotate(-12.5 133.006 149.648)",
    stroke: "#B5B5C2",
    strokeWidth: 0.390625
  }), /*#__PURE__*/React.createElement("rect", {
    x: 110.639,
    y: 135.406,
    width: 112.109,
    height: 112.109,
    rx: 7.61719,
    transform: "rotate(-12.5 110.639 135.406)",
    stroke: "#B5B5C2",
    strokeWidth: 0.390625
  }), /*#__PURE__*/React.createElement("rect", {
    x: 88.2798,
    y: 121.156,
    width: 149.609,
    height: 149.609,
    rx: 7.61719,
    transform: "rotate(-12.5 88.2798 121.156)",
    stroke: "#B5B5C2",
    strokeWidth: 0.390625
  }), /*#__PURE__*/React.createElement("rect", {
    x: 65.9126,
    y: 106.914,
    width: 187.109,
    height: 187.109,
    rx: 7.61719,
    transform: "rotate(-12.5 65.9126 106.914)",
    stroke: "#B5B5C2",
    strokeWidth: 0.390625
  }), /*#__PURE__*/React.createElement("rect", {
    x: 43.5533,
    y: 92.6718,
    width: 224.609,
    height: 224.609,
    rx: 7.61719,
    transform: "rotate(-12.5 43.5533 92.6718)",
    stroke: "#B5B5C2",
    strokeWidth: 0.390625
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21.1861,
    y: 78.4218,
    width: 262.109,
    height: 262.109,
    rx: 7.61719,
    transform: "rotate(-12.5 21.1861 78.4218)",
    stroke: "#B5B5C2",
    strokeWidth: 0.390625
  }), /*#__PURE__*/React.createElement("rect", {
    x: -1.1772,
    y: 64.1718,
    width: 299.609,
    height: 299.609,
    rx: 7.61719,
    transform: "rotate(-12.5 -1.1772 64.1718)",
    stroke: "#B5B5C2",
    strokeWidth: 0.390625
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1465_4942)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 154,
    y: 154,
    width: 48,
    height: 48,
    rx: 9.30247,
    fill: "white",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 154.465,
    y: 154.465,
    width: 47.0698,
    height: 47.0698,
    rx: 8.83735,
    stroke: "#EAECF0",
    strokeWidth: 0.930247,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M198 150C197.072 150 196.182 150.369 195.525 151.025C194.869 151.682 194.5 152.572 194.5 153.5V155.5C193.97 155.5 193.461 155.711 193.086 156.086C192.711 156.461 192.5 156.97 192.5 157.5V162C192.5 162.53 192.711 163.039 193.086 163.414C193.461 163.789 193.97 164 194.5 164H201.5C202.03 164 202.539 163.789 202.914 163.414C203.289 163.039 203.5 162.53 203.5 162V157.5C203.5 156.97 203.289 156.461 202.914 156.086C202.539 155.711 202.03 155.5 201.5 155.5V153.5C201.5 151.567 199.933 150 198 150ZM200.5 155.5V153.5C200.5 152.837 200.237 152.201 199.768 151.732C199.299 151.263 198.663 151 198 151C197.337 151 196.701 151.263 196.232 151.732C195.763 152.201 195.5 152.837 195.5 153.5V155.5H200.5Z",
    fill: "#C13434"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.75 178.75H186.25C186.449 178.75 186.64 178.671 186.78 178.53C186.921 178.39 187 178.199 187 178C187 177.801 186.921 177.61 186.78 177.47C186.64 177.329 186.449 177.25 186.25 177.25H184.75C184.551 177.25 184.36 177.329 184.22 177.47C184.079 177.61 184 177.801 184 178C184 178.199 184.079 178.39 184.22 178.53C184.36 178.671 184.551 178.75 184.75 178.75ZM178 172C178 171.801 178.079 171.61 178.22 171.47C178.36 171.329 178.551 171.25 178.75 171.25H186.25C186.449 171.25 186.64 171.329 186.78 171.47C186.921 171.61 187 171.801 187 172C187 172.199 186.921 172.39 186.78 172.53C186.64 172.671 186.449 172.75 186.25 172.75H178.75C178.551 172.75 178.36 172.671 178.22 172.53C178.079 172.39 178 172.199 178 172ZM178 184C178 183.801 178.079 183.61 178.22 183.47C178.36 183.329 178.551 183.25 178.75 183.25H186.25C186.449 183.25 186.64 183.329 186.78 183.47C186.921 183.61 187 183.801 187 184C187 184.199 186.921 184.39 186.78 184.53C186.64 184.671 186.449 184.75 186.25 184.75H178.75C178.551 184.75 178.36 184.671 178.22 184.53C178.079 184.39 178 184.199 178 184ZM169.75 172.75H171.25C171.449 172.75 171.64 172.671 171.78 172.53C171.921 172.39 172 172.199 172 172C172 171.801 171.921 171.61 171.78 171.47C171.64 171.329 171.449 171.25 171.25 171.25H169.75C169.551 171.25 169.36 171.329 169.22 171.47C169.079 171.61 169 171.801 169 172C169 172.199 169.079 172.39 169.22 172.53C169.36 172.671 169.551 172.75 169.75 172.75ZM171.25 184.75H169.75C169.551 184.75 169.36 184.671 169.22 184.53C169.079 184.39 169 184.199 169 184C169 183.801 169.079 183.61 169.22 183.47C169.36 183.329 169.551 183.25 169.75 183.25H171.25C171.449 183.25 171.64 183.329 171.78 183.47C171.921 183.61 172 183.801 172 184C172 184.199 171.921 184.39 171.78 184.53C171.64 184.671 171.449 184.75 171.25 184.75ZM169 178C169 177.801 169.079 177.61 169.22 177.47C169.36 177.329 169.551 177.25 169.75 177.25H177.25C177.449 177.25 177.64 177.329 177.78 177.47C177.921 177.61 178 177.801 178 178C178 178.199 177.921 178.39 177.78 178.53C177.64 178.671 177.449 178.75 177.25 178.75H169.75C169.551 178.75 169.36 178.671 169.22 178.53C169.079 178.39 169 178.199 169 178ZM175 169.75C174.403 169.75 173.831 169.987 173.409 170.409C172.987 170.831 172.75 171.403 172.75 172C172.75 172.597 172.987 173.169 173.409 173.591C173.831 174.013 174.403 174.25 175 174.25C175.597 174.25 176.169 174.013 176.591 173.591C177.013 173.169 177.25 172.597 177.25 172C177.25 171.403 177.013 170.831 176.591 170.409C176.169 169.987 175.597 169.75 175 169.75ZM178.75 178C178.75 177.403 178.987 176.831 179.409 176.409C179.831 175.987 180.403 175.75 181 175.75C181.597 175.75 182.169 175.987 182.591 176.409C183.013 176.831 183.25 177.403 183.25 178C183.25 178.597 183.013 179.169 182.591 179.591C182.169 180.013 181.597 180.25 181 180.25C180.403 180.25 179.831 180.013 179.409 179.591C178.987 179.169 178.75 178.597 178.75 178ZM175 181.75C174.403 181.75 173.831 181.987 173.409 182.409C172.987 182.831 172.75 183.403 172.75 184C172.75 184.597 172.987 185.169 173.409 185.591C173.831 186.013 174.403 186.25 175 186.25C175.597 186.25 176.169 186.013 176.591 185.591C177.013 185.169 177.25 184.597 177.25 184C177.25 183.403 177.013 182.831 176.591 182.409C176.169 181.987 175.597 181.75 175 181.75Z",
    fill: "#011229"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1465_4942",
    x: 152.14,
    y: 148.07,
    width: 55.721,
    height: 56.721,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.930247
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.930247
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1465_4942"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1465_4942",
    result: "shape"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_1465_4942",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(148.59 214.023) rotate(90) scale(150 150)"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRequestAccessDashboard);
export default __webpack_public_path__ + "static/media/request_access_dashboard.b42db3440b3b8d88c74cb142b7668c19.svg";
export { ForwardRef as ReactComponent };